import React, { useRef, useState } from 'react';

import { SplitButton } from 'primereact/splitbutton';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { AutoComplete, AutoCompleteCompleteMethodParams } from 'primereact/autocomplete';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputMask } from 'primereact/inputmask';

import { ModelOfCategory, ModelOfEspecie, ModelOfFleetExpenditure, ModelOfFuelType, ModelOfUnity } from 'src/database';

import { useListCategoriesController } from 'src/controllers/Category/ListCategoriesController';
import { useListFuelTypesController } from 'src/controllers/FuelType/ListFuelTypesController';
import LoadingScreen from 'src/components/LoadingScreen';
import { useFleetReportsController } from 'src/controllers/DataReports/Fleet/FleetReports';
import { useListEspecieController } from 'src/controllers/Especies/ListEspecieController';
import { useListFuelController } from 'src/controllers/Fuel/ListFuelController';
import { ModelOfAbastecimento } from 'src/modelreport/relabastecimento';
import { dateTimeToString } from 'src/utils/dateToString';
import PrintConsulmoCombustivel from 'src/controllers/Relatorio/RelatorioConsumoCombustivel';
import { useFormCreateContrato } from 'src/controllers/Contrato/CreateContratoController';
import { useListContratosController } from 'src/controllers/Contrato/ListContratosController';
import { useListNegociosController } from 'src/controllers/Negocio/ListNegociosController';

interface filteredFieldProps {
  label: string;
  value?: string;
}

interface Veiculo {
  label: string;
  value?: string;
}

const roundCurrency = (value: number): number =>
  Math.round((value ?? 0) * 100) / 100;

const formatDateForFilename = (dataInicio?: string, dataFim?: string): string => {
  const inicio = dataInicio && dataInicio.length === 10 ? dataInicio : 'sem-data';
  const fim = dataFim && dataFim.length === 10 ? dataFim : 'sem-data';
  return `${inicio} a ${fim}`;
};

const FleetExpenditureReport: React.FC = () => {

  const { getAbastecimentoController, handleAbastecimentoController } = useListFuelController();
  const { abastecimentos, loading, vehicles, postos } = getAbastecimentoController;

  const { getFuelListController } = useListFuelTypesController();
  const { getEspecieListController } = useListEspecieController();
  const { getCategoryListController } = useListCategoriesController();
  const { getFleetReport, handleFleetReport } = useFleetReportsController();

  const { printCallResumoCombustivel } = PrintConsulmoCombustivel();
  const { sendToPrintResumoCombustivel, toastPrintResumocombustivel } = printCallResumoCombustivel;

  const [vehiclesFiltered, setVehiclesFiltered] = useState<ModelOfFleetExpenditure[]>([]);
  const [fuelFilter, setFuelFilter] = useState<ModelOfFuelType | null>(null);
  const [dataInicioFilter, setDataInicioFilter] = useState<string | undefined>('');
  const [dataFimFilter, setDataFimFilter] = useState<string | undefined>('');
  const [categoryFilter, setCategoryFilter] = useState<ModelOfCategory | null>(null);
  const [specieFilter, setSpecieFilter] = useState<ModelOfEspecie | null>(null);
  const [valueUnity, setValueUnity] = useState<filteredFieldProps | null>(null);
  const [valueUnityFatura, setValueUnityFatura] = useState<filteredFieldProps | null>(null);
  const [filteredUnity, setFilteredUnity] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);

  const [valueVehicle, setValueVehicle] = useState('');
  const [selectedVeiculo, setSelectedVeiculo] = useState<Veiculo | null>(null);
  const [filteredVeiculo, setFilteredVeiculo] = useState<Veiculo[]>([]);
  const veiculos: Veiculo[] = [...vehicles];

  const [selectedCreditor, setSelectedCreditor] = useState<filteredFieldProps | null>(null);
  const [filteredCreditor, setFilteredCreditor] = useState<filteredFieldProps[]>([]);

  // --- Dialog Gerar Fatura ---
  const [faturaDialogVisible, setFaturaDialogVisible] = useState(false);
  const [selectedNegocio, setSelectedNegocio] = useState<any>(null);
  const [selectedContrato, setSelectedContrato] = useState<any>(null);
  const [negocioSuggestions, setNegocioSuggestions] = useState<any[]>([]);
  const [contratoSuggestions, setContratoSuggestions] = useState<any[]>([]);
  const { getContratoListController, handleContratoListController } = useListContratosController();
  const { getNegocioListController, handleNegocioListController } = useListNegociosController();
  const [faturaLoading, setFaturaLoading] = useState(false);


  const searchNegocio = (event: AutoCompleteCompleteMethodParams) => {
    const query = event.query.toLowerCase();
    const results = getNegocioListController.NegociosData.filter((negocio: any) =>
      negocio.CNPJ?.toLowerCase().includes(query) ||
      negocio.RAZAOSOCIAL?.toLowerCase().includes(query)
    ).map((negocio: any) => ({
      label: `${negocio.CNPJ} - ${negocio.RAZAOSOCIAL}`,
      value: negocio.ID,
    }));

    setNegocioSuggestions(results);
  };

  const searchContrato = (event: AutoCompleteCompleteMethodParams) => {
    const query = event.query.toLowerCase();
    const results = getContratoListController.ContratosData.filter((contrato: any) =>
      contrato.NUMERO?.toLowerCase().includes(query) ||
      contrato.DESCRICAO?.toLowerCase().includes(query)
    ).map((contrato: any) => ({
      label: `${contrato.NUMERO} - ${contrato.DESCRICAO}`,
      value: contrato.ID,
    }));

    setContratoSuggestions(results);
  };

  const handleCloseFaturaDialog = () => {
    setFaturaDialogVisible(false);
    setSelectedNegocio(null);
    setSelectedContrato(null);

  };
  // --------------------------

  const searchVeiculo = (event: AutoCompleteCompleteMethodParams) => {
    const query = event.query.toLowerCase();
    const results = veiculos.filter(veiculo =>
      veiculo.label.toLowerCase().includes(query)
    );
    setFilteredVeiculo(results);
  };

  const searchCreditor = (event: AutoCompleteCompleteMethodParams) => {
    const query = event.query.toLowerCase();
    const results = postos.filter(p =>
      p.label.toLowerCase().includes(query)
    );
    setFilteredCreditor(results);
  };

  const unitys = getAbastecimentoController.UnitysData.map(unity => ({
    label: unity.NOME,
    value: unity.ID,
  }));

  const searchUnitys = (event: any) => {
    let filteredUnitys;
    if (!event.query.trim().length) {
      filteredUnitys = [...unitys];
    } else {
      filteredUnitys = unitys.filter(unity =>
        unity.label.toLowerCase().includes(event.query.toLowerCase())
      );
    }
    setFilteredUnity(filteredUnitys);
  };

  const fuelTypes = getFuelListController.fuelTypesData.map(ft => ft);
  const species = getEspecieListController.EspecieData.map(s => s);
  const categorys = getCategoryListController.categoriesData.map(c => c);

  const dataTable: any = useRef(null);

  const sanitizedData = abastecimentos.map(item => ({
    ...item,
    VALORCOMBUSTIVEL: roundCurrency(item.VALORCOMBUSTIVEL),
    VALORTOTAL: roundCurrency(item.VALORTOTAL),
    VALORLIQUIDO: roundCurrency(item.VALORLIQUIDO),
    TAXAADM: roundCurrency(item.TAXAADM),
  }));

  const exportCSV = () => {
    const headers = [
      'HORA', 'ESTABELECIMENTO', 'CNPJ', 'PLACA', 'TIPO COMBUSTIVEL',
      'QTD AUTORIZADO', 'QTD EFETIVADA', 'VLR COMBUSTIVEL', 'VLR TOTAL',
      'MOTORISTA', 'IDENTIFICACAO', 'DESCCARTAO',
    ];

    const csvContent = [
      headers.join(';'),
      ...sanitizedData.map(row => [
        row.HORA,
        row.NOMEPESSOA,
        row.CNPJ,
        row.PLACA,
        row.DESCTIPOCOMBUSTIVEL,
        row.QUANTIDADECOMBUSTIVELSOLICITADO,
        row.QTDEFETIVADA,
        String(row.VALORCOMBUSTIVEL).replace('.', ','),
        String(row.VALORTOTAL).replace('.', ','),
        row.MOTORISTA,
        row.IDENTIFICACAO,
        row.DESCCARTAO,
      ].join(';')),
    ].join('\n');

    const periodo = formatDateForFilename(dataInicioFilter, dataFimFilter);
    const nomeArquivo = `RELATÓRIO CONSUMO ${periodo}.csv`;
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    link.click();
    URL.revokeObjectURL(url);
  };

  const exportItems = [
    {
      label: 'Exportar PDF',
      icon: 'pi pi-upload',
      command: () => {
        toastPrintResumocombustivel.current?.show({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'Gerando arquivo.',
          life: 3000,
        });
        sendToPrintResumoCombustivel(abastecimentos);
      },
    },
    {
      label: 'Exportar CSV',
      icon: 'pi pi-upload',
      command: exportCSV,
    },
    {
      label: 'Gerar Fatura',
      icon: 'pi pi-file',
      command: () => setFaturaDialogVisible(true),
    },
  ];

  const handleFilter = (vehicleData: ModelOfFleetExpenditure[]) => {
    let filterObj = {
      'DESCRICAO_CATEGORIA': categoryFilter || '',
      'TIPOCOMBUSTIVEL': fuelFilter || '',
      'DESCRICAO_ESPECIE': specieFilter || '',
    };

    const filterKeys = Object.keys(filterObj);
    const filterValues = Object.values(filterObj);

    return vehicleData.filter((item: any) =>
      filterKeys.every((value, eachKey) => {
        if (!filterValues[eachKey]) return true;
        return filterValues[eachKey]?.toString().includes(item[value]);
      })
    );
  };

  if (getFleetReport.loading) {
    return <LoadingScreen />;
  }

  return (
    <div>
      <Toast ref={toastPrintResumocombustivel} />

      {/* Dialog Gerar Fatura */}
      <Dialog
        header="Gerar Fatura"
        visible={faturaDialogVisible}
        style={{ width: '450px' }}
        onHide={handleCloseFaturaDialog}
        footer={
          <div>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={handleCloseFaturaDialog}
            />
            <Button
              label="Criar Fatura"
              icon={faturaLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
              disabled={!selectedNegocio || !selectedContrato || faturaLoading}
              onClick={async () => {
                setFaturaLoading(true);
                await handleNegocioListController.criarFatura({
                  idOrgaoUnidade: valueUnityFatura?.value || '',
                  dataInicio: dataInicioFilter ?? '',
                  dataFim: dataFimFilter ?? '',
                  negocio: selectedNegocio,
                  contrato: selectedContrato,
                  vehicleData: sanitizedData,
                  toast: toastPrintResumocombustivel,
                });
                setFaturaLoading(false);
                handleCloseFaturaDialog();
              }}
            />
          </div>
        }
      >
        <div className="p-fluid p-grid">
          <div className="p-field p-col-12">
            <label htmlFor="negocio">Negócio</label>
            <AutoComplete
              id="negocio"
              value={selectedNegocio}
              suggestions={negocioSuggestions}
              completeMethod={searchNegocio}
              field="label"
              dropdown
              onDropdownClick={() => {
                if (getNegocioListController.NegociosData.length === 0) {
                  handleNegocioListController.getNegocios();
                }
              }}
              onChange={(e) => setSelectedNegocio(e.value)}
              placeholder="Buscar negócio..."
              style={{ width: '100%' }}
            />
          </div>
          <div className="p-field p-col-12">
            <label htmlFor="contrato">Contrato</label>
            <AutoComplete
              id="contrato"
              value={selectedContrato}
              suggestions={contratoSuggestions}
              completeMethod={searchContrato}
              field="label"
              dropdown
              onDropdownClick={() => {
                if (getContratoListController.ContratosData.length === 0) {
                  handleContratoListController.getContratos();
                }
              }}
              onChange={(e) => setSelectedContrato(e.value)}
              placeholder="Buscar contrato..."
              style={{ width: '100%' }}
            />
          </div>


          <div className="p-field p-col-12">
            <label htmlFor="unidade">Setor</label>
            <AutoComplete
              id="unidade"
              value={valueUnityFatura}
              field="label"
              placeholder="Buscar..."
              onChange={e => setValueUnityFatura(e.value)}
              onSelect={e => setValueUnityFatura(e.value)}
              suggestions={filteredUnity}
              completeMethod={searchUnitys}
              dropdown
              dropdownMode="current"
              minLength={2}
              delay={80}
            />
          </div>


        </div>
      </Dialog>

      <div style={{ height: '100%' }} className="card p-align-center p-justify-center">
        <form className="p-grid p-fluid">

          <div className="p-field p-col-12 p-md-4">
            <label htmlFor="descricao">Veículo</label>
            <AutoComplete
              id="vehicle"
              value={selectedVeiculo}
              suggestions={filteredVeiculo}
              completeMethod={searchVeiculo}
              onSelect={e => setValueVehicle(e.value.label)}
              field="label"
              dropdown
              onChange={(e) => setSelectedVeiculo(e.value)}
              placeholder="Selecione o Veículo..."
            />
          </div>

          <div className="p-field p-col-12 p-md-2">
            <label htmlFor="dataInicio">Data Início</label>
            <InputMask
              type="text"
              mask="99/99/9999"
              value={dataInicioFilter}
              onChange={e => setDataInicioFilter(e.target.value)}
              placeholder="__/__/____"
            />
          </div>

          <div className="p-field p-col-12 p-md-2">
            <label htmlFor="dataFim">Data Fim</label>
            <InputMask
              type="text"
              mask="99/99/9999"
              value={dataFimFilter}
              onChange={e => setDataFimFilter(e.target.value)}
              placeholder="__/__/____"
            />
          </div>

          <div className="p-field p-col-3">
            <label htmlFor="unidade">Setor</label>
            <AutoComplete
              id="unidade"
              value={valueUnity}
              field="label"
              placeholder="Buscar..."
              onChange={e => setValueUnity(e.value)}
              onSelect={e => setValueUnity(e.value)}
              suggestions={filteredUnity}
              completeMethod={searchUnitys}
              dropdown
              dropdownMode="current"
              minLength={2}
              delay={80}
            />
          </div>

          <div className="p-field p-col-12 p-md-3">
            <label htmlFor="tipoComb">Tipo Combustível</label>
            <Dropdown
              id="tipoComb"
              value={fuelFilter}
              showClear
              placeholder="Selecionar tipo combustível"
              onChange={(e) => setFuelFilter(e.value)}
              options={fuelTypes}
              optionLabel="DESCRICAO"
            />
          </div>

          <div className="p-field p-col-12 p-md-3">
            <label htmlFor="categoria">Categoria</label>
            <Dropdown
              id="categoria"
              value={categoryFilter}
              showClear
              placeholder="Selecionar categoria"
              onChange={(e) => setCategoryFilter(e.value)}
              options={categorys}
              optionLabel="DESCRICAO"
            />
          </div>

          <div className="p-field p-col-12 p-md-3">
            <label htmlFor="especie">Espécie</label>
            <Dropdown
              id="especie"
              value={specieFilter}
              showClear
              placeholder="Selecionar espécie"
              onChange={(e) => setSpecieFilter(e.value)}
              options={species}
              optionLabel="DESCRICAO"
            />
          </div>

          <div className="p-field p-col-12 p-md-4">
            <label htmlFor="posto">Posto</label>
            <AutoComplete
              id="posto"
              value={selectedCreditor}
              suggestions={filteredCreditor}
              completeMethod={searchCreditor}
              onSelect={e => setSelectedCreditor(e.value)}
              field="label"
              dropdown
              onChange={e => setSelectedCreditor(e.value)}
              placeholder="Selecione o posto..."
            />
          </div>

          <div className="p-field p-col-12 p-md-3">
            <label>Para filtrar dados clique aqui</label>
            <SplitButton
              model={exportItems}
              icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-search'}
              label="Exibir relatório"
              disabled={loading}
              onClick={() => {
                handleAbastecimentoController.motaAbastecimento(
                  fuelFilter, categoryFilter, specieFilter,
                  dataInicioFilter, dataFimFilter,
                  valueUnity?.value, selectedVeiculo?.value,
                  selectedCreditor?.value
                );
                setVehiclesFiltered(handleFilter(getFleetReport.fleetExpenditureData));
              }}
            />
          </div>

        </form>
      </div>

      <ReportsComponent tableRef={dataTable} vehicleData={sanitizedData} />
    </div>
  );
};

interface VehicleDataProps {
  vehicleData: ModelOfAbastecimento[];
  tableRef: any;
}

const ReportsComponent: React.FC<VehicleDataProps> = ({ vehicleData, tableRef }) => {

  const HEADER_TIPOCOMBUSTIVEL = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">TIPO COMBUSTÍVEL</span>
      <span style={{ fontSize: '10px' }}>{rowData.DESCTIPOCOMBUSTIVEL}</span>
    </React.Fragment>
  );

  const HEADER_QUANTIDADECOMBUSTIVELSOLICITADO = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">QTD</span>
      <span style={{ fontSize: '10px' }}>{rowData.QUANTIDADECOMBUSTIVELSOLICITADO}</span>
    </React.Fragment>
  );

  const HEADER_QTDEFETIVADA = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">QTD</span>
      <span style={{ fontSize: '10px' }}>{rowData.QTDEFETIVADA}</span>
    </React.Fragment>
  );

  const HEADER_HORA = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">HORA</span>
      <span style={{ fontSize: '10px' }}>{dateTimeToString(rowData.HORA, 'br')}</span>
    </React.Fragment>
  );

  const HEADER_PLACA = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">PLACA</span>
      <span style={{ fontSize: '10px' }}>{rowData.PLACA}</span>
    </React.Fragment>
  );

  const HEADER_ESTABELECIMENTO = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">ESTABELECIMENTO</span>
      <span style={{ fontSize: '10px' }}>{rowData.NOMEPESSOA}</span>
    </React.Fragment>
  );

  const HEADER_CNPJ = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">CNPJ</span>
      <span style={{ fontSize: '10px' }}>{rowData.CNPJ}</span>
    </React.Fragment>
  );

  const HEADER_IDENTIFICACAO = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">IDENTIFICAÇÃO</span>
      <span style={{ fontSize: '10px' }}>{rowData.IDENTIFICACAO}</span>
    </React.Fragment>
  );

  const HEADER_MOTORISTA = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">MOTORISTA</span>
      <span style={{ fontSize: '10px' }}>{rowData.MOTORISTA}</span>
    </React.Fragment>
  );

  const HEADER_DESCCARTAO = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">DESC. CARTÃO</span>
      <span style={{ fontSize: '10px' }}>{rowData.DESCCARTAO}</span>
    </React.Fragment>
  );

  const HEADER_TAXAADM = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">TAXA</span>
      <span style={{ fontSize: '10px' }}>
        {(rowData.TAXAADM ?? 0).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </React.Fragment>
  );

  const HEADER_VALORCOMBUSTIVEL = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">VLR BRUTO LITRO</span>
      <span style={{ fontSize: '10px' }}>
        {(rowData.VALORCOMBUSTIVEL ?? 0).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </React.Fragment>
  );

  const HEADER_VALORLIQUIDO = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">VLR LÍQUIDO</span>
      <span style={{ fontSize: '10px' }}>
        {(rowData.VALORLIQUIDO ?? 0).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </React.Fragment>
  );

  const HEADER_VALORTOTAL = (rowData: ModelOfAbastecimento) => (
    <React.Fragment>
      <span className="left-header">VLR TOTAL</span>
      <span style={{ fontSize: '10px' }}>
        {(rowData.VALORTOTAL ?? 0).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </React.Fragment>
  );

  return (
    <div className="p-card p-p-4">
      <DataTable
        value={vehicleData}
        ref={tableRef}
        header={
          <div className="table-header p-grid p-d-flex p-jc-between">
            <h5>Relatório de Consumo</h5>
          </div>
        }
        className="responsive-table p-datatable-sm"
        dataKey="HORA"
        autoLayout
      >
        <Column field="HORA" header="HORA" body={HEADER_HORA} style={{ fontSize: '11px' }} />
        <Column field="NOMEPESSOA" header="ESTABELECIMENTO" body={HEADER_ESTABELECIMENTO} style={{ fontSize: '11px' }} />
        <Column field="CNPJ" header="CNPJ" body={HEADER_CNPJ} style={{ fontSize: '11px' }} />
        <Column field="PLACA" header="PLACA" body={HEADER_PLACA} style={{ fontSize: '11px' }} />
        <Column field="DESCTIPOCOMBUSTIVEL" header="TIPO COMBUSTIVEL" body={HEADER_TIPOCOMBUSTIVEL} style={{ fontSize: '11px' }} />
        <Column field="QUANTIDADECOMBUSTIVELSOLICITADO" header="QTD AUTORIZADO" body={HEADER_QUANTIDADECOMBUSTIVELSOLICITADO} style={{ fontSize: '11px' }} bodyStyle={{ textAlign: 'right' }} />
        <Column field="QTDEFETIVADA" header="QTD EFETIVADA" body={HEADER_QTDEFETIVADA} style={{ fontSize: '11px' }} bodyStyle={{ textAlign: 'right' }} />
        <Column field="VALORCOMBUSTIVEL" header="VLR COMBUSTIVEL" body={HEADER_VALORCOMBUSTIVEL} style={{ fontSize: '11px' }} bodyStyle={{ textAlign: 'right' }} />
        <Column field="VALORTOTAL" header="VLR TOTAL" body={HEADER_VALORTOTAL} style={{ fontSize: '11px' }} bodyStyle={{ textAlign: 'right' }} />
        <Column field="MOTORISTA" header="MOTORISTA" body={HEADER_MOTORISTA} style={{ fontSize: '11px' }} />
        <Column field="IDENTIFICACAO" header="IDENTIFICACAO" body={HEADER_IDENTIFICACAO} style={{ fontSize: '11px' }} />
        <Column field="DESCCARTAO" header="DESCCARTAO" body={HEADER_DESCCARTAO} style={{ fontSize: '11px' }} />
      </DataTable>
    </div>
  );
};

export default FleetExpenditureReport;